import { useDispatch, useSelector } from 'react-redux';
import TextareaAutosize from 'react-textarea-autosize';
import { decrementFromCart, setCartCount, addToCart } from '../../store/inquerySlice';
import { DataContainer } from '../DataContainer';
import { useEffect, useState } from 'react';
import { ensureAll, fetchAll } from '../../store/foodPackagesSlice';
import { URL_PREFIX } from '../../api';


function ExtraServices(props) {
    const dispatch = useDispatch();

    const _foodPackages = useSelector((state) => state.foodPackages.knownFoodPackages);
    // Order by price ascending
    const foodPackages = Object.values(_foodPackages).sort((a, b) => a.food_package_price - b.food_package_price);

    // { id: str, count: number }[]
    const cart = useSelector((state) => state.inquery.foodPackages);

    const cartTotal = cart.reduce((acc, item) => {
        const foodPackage = foodPackages.find((foodPackage) => foodPackage.food_package_id === item.id);
        return acc + (foodPackage ? foodPackage.food_package_price * item.count : 0);
    }, 0).toFixed(2);

    function getCartCount(id) {
        const index = cart.findIndex((item) => item.id === id);
        if(index === -1) return 0;
        return cart[index].count;
    }

    useEffect(() => {
        dispatch(ensureAll());
    });

    return (
        <form className="section" id="inquery-required-check" onSubmit={(e) => e.preventDefault()} >
            <div className="column g16 top">
                <p className="title">LISATEENUSED</p>
                <p>Lisateenused bussi</p>
            </div>
            <div className="column g32 p32">
                <div className="column">
                    <h2>Toitlustus</h2>
                    <p>Valige toidupakid, mida soovite bussi.</p>
                </div>

                <DataContainer actionType={"foodPackages/fetchAll"}>
                    <div className="column g16">
                        {foodPackages.map((foodPackage) => (
                            <div className="row g8 center-cross">
                                <img
                                    src={URL_PREFIX + "/storage/food_package/" + foodPackage.food_package_id.toLowerCase() + ".jpg"}
                                    style={{ objectFit: 'cover', width: 128, height: '100%', borderRadius: 4 }}
                                />
                                <div className="column g8">
                                    <div className="column">
                                        <b>{foodPackage.food_package_name} • {foodPackage.food_package_price} €</b>
                                        <p>{foodPackage.food_package_description}</p>
                                    </div>

                                    <div className="row center-cross" style={{ height: 36 }}>
                                        <button style={{ paddingInline: 10, height: '100%' }} onClick={() => dispatch(decrementFromCart({ id: foodPackage.food_package_id }))}>-</button>
                                        <input style={{ height: '100%', width: 64, textAlign: 'center' }} type="text" value={getCartCount(foodPackage.food_package_id)} onChange={(e) => dispatch(setCartCount({ id: foodPackage.food_package_id, count: +e.target.value }))} onFocus={(e) => e.target.select()} />
                                        <button style={{ paddingInline: 10, height: '100%' }} onClick={() => dispatch(addToCart({ id: foodPackage.food_package_id }))}>+</button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </DataContainer>

                <div className="column g8">
                    <div className="hr"></div>

                    <div className="row center-cross g16" style={{ justifyContent: 'space-between' }}>
                        <b style={{ color: '#888', fontSize: 14 }}>KOKKU:</b>
                        <p>{cartTotal} €</p>
                    </div>
                </div>
            </div>
        </form>
    )
};

export default ExtraServices;